module.exports = __webpack_public_path__ + "img/granary1.53c3c2f7.png";